import { STORAGE_CONFIG } from "../../constants/storageConfig";

export const ALERT_TRIANGLE = 'triangle';
export const ALERT_SUCCESS = 'checkmarkcircle';
export const ALERT_ERROR = 'error';
export const HOME_PAGE_TITLE = 'Sunbelt Rentals - Equipment & Tool Rental Company';
export const EQUIPMENT_AND_TOOLS_TITLE = 'Equipment and Tools | Sunbelt Rentals';
export const FREE_DELIVERY = 'Y';
export const FREE_PICKUP = 'Y';
export const REDIRECTING = 'redirecting';
export const MEDIA_TYPE = {
    mobile: 'MOBILE',
    desktop: 'DESKTOP'
};
export const LIMIT_TO_SHOW_SEARCH_BAR = 20;
export const SEARCH_INPUT_LIMIT = 3;
export const SUCCESS = 'Success';
export const WARNING = 'Warning';
export const ERROR = 'Error';

export const AUTHORITY_TYPE = {
    DOTCOM: 'DOTCOM',
    P2P: 'P2P',
    PUNCHOUT: 'PUNCHOUT'
};
export const P2P_ASIDE_NAV = [
    { keyword: 'quotes', title: 'Quotes' },
    { keyword: 'purchaseorders', title: 'PO Management' }
];

// Add constants in this array in Lowercase only
export const ADDONS_SYNONYMS_ARRAY = ['merchandise', 'parts'];

export const ENV_CONFIGS = {
    production: {
        muledomain: 'https://api.sunbeltrentals.com',
        clientId: '0oa56ipgl8SAfB1kE5d7',
        clientsecretcode: '6yNzPOIbav3xJ0XMFRI9cCKjEmqcKXiPVPhQS7eo',
        openIdKey: '95aec74893c84c3faed1bc6dec0aa335' // TODO: need to update for prod
    },
    stage: {
        muledomain: 'https://stage-api.sunbeltrentals.com',
        clientId: '0oa6zqnsiyDYBDHSk1d7',
        clientsecretcode: '1sygtwuROKfdrBEiX-yEeypqrATE82e46lPb10n1',
        openIdKey: '95aec74893c84c3faed1bc6dec0aa335' // TODO: need to update for stage
    },
    qa: {
        muledomain: 'https://qa-api.sunbeltrentals.com',
        clientId: '3dfbdf465f24483d8be8e9af7dc5396c',
        clientsecretcode: '9622F5a954Dc4cfeb86993324351fFe6',
        openIdKey: '95aec74893c84c3faed1bc6dec0aa335'
    }
};
export const EMPLOYEE = 'employee';
export const FORCE_ITEM = {
    YES: 'Y',
    NO: 'N'
};
export const INCREMENT = 'Increment';
export const DECREMENT = 'Decrement';
export const CHECKOUT_CHOOSE_STORE_HEADER_ID = 'choose-store-header';
export const CLOSED = 'Closed';
export const SAVE_FOR_LATER = 'SAVE_FOR_LATER';
export const EQUIPMENT_ON_RENT = 'Equipment on Rent';

export const PRODUCT_TILE_VARIANT = {
    LIST_VIEW: 'tile',
    GRID_VIEW: 'grid'
};
export const BAHAMAS_COMPANY_ID = "10";
export const PRODUCT_CARDS_MOBILE_RESPONSIVE = {
    mobile: 2,
    smalltablet: 2,
    tablet: 2,
    smalldesktop: 4,
    desktop: 4
};

export const COMPANY_IDS ={
    '1': 'us',
    '2': 'ca'
};

export const STOCK_CLASS_FUEL = 'FUEL';
export const STOCK_CLASS_MISCELLANEOUS = 'MISC';

export const VIEW_SIMILAR_ITEMS_MAX_COUNT = {
    PDP: 4,
    CART: 3
};

export const I2P_BANNER_IDENTIFIER = 'employee_i2p';

export const VIEWPORT_WIDTHS = {
    DESKTOP: 1024,
    TABLET: 640
};

export const AEM_MEDIA_URL = {
    IMAGE: 'https://media.sunbeltrentals.com/is/image/',
    CONTENT: 'https://media.sunbeltrentals.com/is/content/',
    DIMENSIONAL_VIEWER: 'https://media.sunbeltrentals.com/s7viewers/html5/js/DimensionalViewer.js',
    VIDEO_VIEWER: 'https://media.sunbeltrentals.com/s7viewers/html5/js/VideoViewer.js'
};

export const LOCAL_STORAGE_PRESERVE_KEYS = [STORAGE_CONFIG.LOCAL_STORAGE.COMPANYID, 'EQUIPMENT_GRID_STATE', 'equipmentDrawerSettings', 'livemap-expanded-jobsite-groups'];
